export default __webpack_public_path__ + "static/media/FI_all.7c0f61dc.txt";